<template>
  <div class="flex w-full loading-wrapper items-center justify-center">
    <div id="loading-container" class="w-10 h-10 vs-con-loading__container"></div>
  </div>
</template>

<script>
import { getApiKey, getBPMTsGenerateTokenUrl, getLighthouseSupportedAppsUrl } from '@/utils/misc'
import axios from 'axios'
import customConnections from './customConnections'
export default {
  name: 'ConnectComponent',
  data() {
    return {
      status: 'pending',
    }
  },
  watch: {
    status() {
      if (this.status === 'completed') this.$router.push({ path: '/settings' })
    },
  },
  computed: {
    installKey() {
      return this.$route.params.key
    },
  },
  async mounted() {
    this.$vs.loading({ container: `#loading-container`, scale: 0.5 })

    const cmsApp = await this.getCMSApp(this.installKey)
    if (!cmsApp) {
      this.showError()
      return
    }
    if (cmsApp.attributes.authType === 'custom' || cmsApp.attributes.flow === 'custom') {
      try {
        const result = await customConnections({ appSlug: cmsApp.attributes.slug, params: this.$route.query, apiKey: getApiKey() })
        this.customAuthDone(result)
      } catch (error) {
        this.$rollbar.error(`Unable to do Custom Auth`, { for: this.installKey, error, params: this.$route.query })
        this.showError()
      }
    } else if (this.isCodeExist()) {
      await this.connectToBMApi(this.installKey, this.$route.query)
    } else {
      this.$vs.notify({
        title: 'Info',
        text: 'Please start the authentication from the settings page.',
        color: 'primary',
      })
      this.status = 'error'
      setTimeout(() => {
        this.status = 'completed'
      }, 2000)
    }
  },
  methods: {
    /**
     * @description Method to be called when custom authentication is done
     */
    async customAuthDone(result) {
      if (result && result.code) {
        await this.connectToBMApi(this.installKey, result)
      } else this.status = 'completed'
    },
    /**
     * @description  Get CMS App by its slug
     * @param {string} slug CMS App slug
     * @returns {Promise<Object | null>}
     */
    async getCMSApp(appSlug) {
      const { data: apps } = await axios.get(getLighthouseSupportedAppsUrl(appSlug))
      return apps.data && apps.data.length ? apps.data[0] : null
    },
    /**
     * @description Check if the code is valid
     * @returns {boolean}
     */
    isCodeExist() {
      return this.$route.query.code != null
    },
    /**
     * @description Connect to the BMA api
     * @returns {Promise<void>}
     */
    async connectToBMApi(appName, params) {
      try {
        await axios.get(getBPMTsGenerateTokenUrl({ ...params, appName, apiToken: getApiKey() }))
        this.status = 'completed'
      } catch (error) {
        this.showError()
        this.$rollbar.error('Unable to Generate Token', { for: appName, error, params })
      }
    },
    /**
     * @description Show error & set status to completed after 2 seconds.
     */
    showError() {
      this.status = 'error'
      this.$vs.notify({
        title: 'Authentication failed',
        text: 'We were unable to connect to the app. Please try again.',
        color: 'warning',
      })
      setTimeout(() => {
        this.status = 'completed'
      }, 2000)
    },
    /**
     * @description Remove code from query
     * @returns {void}
     */
    removeCodeFromLocation() {
      const params = this.$route.query
      delete params['code']
      history.pushState({}, null, `${this.$route.path}?${new URLSearchParams(params).toString()}`)
    },
  },
}
</script>

<style>
.loading-wrapper {
  height: 60vh;
}
</style>
